if (!customElements.get("cart-complementary-products")) {
  customElements.define(
    "cart-complementary-products",
    class CartComplementaryProducts extends HTMLElement {
      connectedCallback() {
        this.exclude_rings_by_size = this.dataset.excludeRingsBySize;
        this.abortController = new AbortController();
        this.load();
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      async load() {
        const productId = this.dataset.productId;
        const container = this.querySelector("[data-swiper-container]");

        if (!productId || !container) return;

        try {
          console.log("Exclude rings by size:", this.exclude_rings_by_size);

          let products = await this.fetchProducts(productId, "complementary");

          // Shopify only auto-generates the "related" recommendation set.
          // Use it when no complementary products were configured manually.
          if (!products.length) {
            products = await this.fetchProducts(productId, "related");
          }

          console.log("PRODUCTS: ", products)

          if (!products.length) {
            this.hidden = true;
            return;
          }

          if (this.exclude_rings_by_size) {

            const sizeOptionNames = [
              "Ring size",
              "Size",
              "Veličina",
              "Unutrašnji prečnik prstena",
            ];

            products = products.filter((product) => {
              const isRing = product.tags?.includes("Prsten") ?? false;

              const hasSizeOption =
                product.options?.some((option) =>
                  sizeOptionNames.includes(option.name),
                ) ?? false;

              console.log("isRing ", isRing);
              console.log("hasSizeOption", hasSizeOption);

              return !(isRing && hasSizeOption);
            });
          }

          if (!products.length) {
            this.hidden = true;
            return;
          }

          container.replaceChildren(
            ...products.map((product) => this.createSlide(product)),
          );
          this.hidden = false;
          await this.updateSlider();
        } catch (error) {
          if (error.name !== "AbortError") {
            console.error("Unable to load complementary cart products", error);
          }
          this.hidden = true;
        }
      }

      async fetchProducts(productId, intent) {
        const url = new URL(
          this.dataset.recommendationsUrl,
          window.location.origin,
        );
        url.searchParams.set("product_id", productId);
        url.searchParams.set("limit", this.dataset.limit || "5");
        url.searchParams.set("intent", intent);
        url.searchParams.set("section_id", this.dataset.recommendationsSection);

        const response = await fetch(url, {
          signal: this.abortController.signal,
          credentials: "same-origin",
          headers: { Accept: "text/html" },
        });

        if (!response.ok) {
          throw new Error(`Recommendations request failed: ${response.status}`);
        }

        const html = new DOMParser().parseFromString(
          await response.text(),
          "text/html",
        );
        const data = html.querySelector("[data-cart-complementary-products-json]");
        if (!data) {
          throw new Error("Recommendations response is missing product data");
        }
        const { products = [] } = JSON.parse(data.textContent);
        return products;
      }

      createSlide(product) {
        const slide = document.createElement("div");
        const variant =
          product.variants?.find((item) => item.available) ||
          product.variants?.[0];
        const productUrl = product.url || `/products/${product.handle}`;
        const imageUrl =
          typeof product.featured_image === "string"
            ? product.featured_image
            : product.featured_image?.url || product.images?.[0] || "";
        const available = Boolean(variant?.available);
        const formId = `CartDrawerComplementary-${product.id}`;
        const addLabel = this.dataset.addLabel || "Add to cart";
        const soldOutLabel = this.dataset.soldOutLabel || "Sold out";
        const buttonLabel = available ? addLabel : soldOutLabel;
        const image = imageUrl
          ? `<a href="${this.escape(productUrl)}" aria-label="${this.escape(product.title)}">
              <picture class="lux-complementary__card-picture">
                <img
                  src="${this.escape(imageUrl)}"
                  alt="${this.escape(product.featured_image?.alt || product.title)}"
                  class="lux-complementary__card-image"
                  width="400"
                  height="400"
                  loading="lazy"
                >
              </picture>
            </a>`
          : "";

        slide.className =
          "lux-complementary__slide swiper-slide wt-slider__slide";
        slide.setAttribute("data-swiper-slide", "");
        slide.innerHTML = `
          <article class="lux-complementary__card">
            ${image}
            <div class="lux-complementary__card-body">
              <h3 class="lux-complementary__card-title">
                <a href="${this.escape(productUrl)}">${this.escape(product.title)}</a>
              </h3>
              <div class="lux-complementary__card-price">${product.price_html}</div>
              <product-form class="lux-complementary__card-form-wrapper">
                <form
                  method="post"
                  action="${this.escape(this.dataset.cartAddUrl || "/cart/add")}" 
                  id="${this.escape(formId)}"
                  class="wt-product__add-to-cart_form form lux-complementary__card-form"
                  data-type="add-to-cart-form"
                >
                  <div class="wt-product__add-to-cart_form--wrapper">
                    <input type="hidden" name="id" value="${this.escape(variant?.id || "")}">
                    <button
                      aria-label="${this.escape(buttonLabel)}"
                      id="ProductSubmitButton-${this.escape(formId)}"
                      type="submit"
                      name="add"
                      data-is-product-available="${available}"
                      class="product-form__submit lux-complementary__card-submit"
                      ${available ? "" : "disabled"}
                    >
                      <span class="product-button-pricing__wrapper">
                        <span class="product-button-pricing">
                          <span class="product-button-pricing__label">${this.escape(buttonLabel)}</span>
                        </span>
                      </span>
                      <span class="loading-overlay__spinner hidden">
                        <span class="lds-ring" aria-hidden="true">
                          <span></span><span></span><span></span><span></span>
                        </span>
                      </span>
                    </button>
                  </div>
                </form>
                <div class="product-form__error-message-wrapper">
                  <p class="product-form__error-message"></p>
                </div>
              </product-form>
            </div>
          </article>`;

        return slide;
      }

      async updateSlider() {
        await customElements.whenDefined("slideshow-section");
        await new Promise((resolve) => requestAnimationFrame(resolve));

        const slider = this.querySelector("slideshow-section");
        slider?.swiper?.updateSize();
        slider?.swiper?.updateSlides();
        slider?.swiper?.update();
      }

      escape(value) {
        return String(value ?? "")
          .replaceAll("&", "&amp;")
          .replaceAll('"', "&quot;")
          .replaceAll("'", "&#039;")
          .replaceAll("<", "&lt;")
          .replaceAll(">", "&gt;");
      }
    },
  );
}
